export default {
      id: "warning-usage",
      viewBox: "0 0 33 27",
      url: __webpack_public_path__ + "img/icons.svg#warning",
      toString: function () {
        return this.url;
      }
    }